// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root MuiContainer-maxWidthSm"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        />
      </div>
      <div
        class="MuiContainer-root MuiContainer-maxWidthSm"
      >
        <form
          accept-charset="UTF-8"
          action="/users/password"
          id="user_password"
          method="post"
        >
          <input
            name="_method"
            type="hidden"
            value="put"
          />
          <input
            name="utf8"
            type="hidden"
            value="✓"
          />
          <input
            name="authenticity_token"
            type="hidden"
            value=""
          />
          <input
            id="user_reset_password_token"
            name="user[reset_password_token]"
            type="hidden"
            value="foo"
          />
          <input
            id="user_password"
            name="user[password]"
            type="hidden"
            value=""
          />
          <input
            id="user_password_confirmation"
            name="user[password_confirmation]"
            type="hidden"
            value=""
          />
        </form>
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <h3
              class="MuiTypography-root MuiTypography-h3"
            >
              Change your password
            </h3>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div>
              <div
                class="MuiFormControl-root MuiFormControl-fullWidth"
              >
                <label
                  class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                  data-shrink="false"
                  for="password"
                >
                  Password
                  <span
                    aria-hidden="true"
                    class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                  >
                     
                    *
                  </span>
                </label>
                <div
                  class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
                  required=""
                >
                  <input
                    aria-invalid="false"
                    class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
                    id="password"
                    required=""
                    type="password"
                    value=""
                  />
                  <div
                    class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
                  >
                    <button
                      aria-label="toggle password visibility"
                      class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
                      tabindex="0"
                      type="button"
                    >
                      <span
                        class="MuiIconButton-label"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                          />
                        </svg>
                      </span>
                      <span
                        class="MuiTouchRipple-root"
                      />
                    </button>
                  </div>
                  <fieldset
                    aria-hidden="true"
                    class="PrivateNotchedOutline-root-1 MuiOutlinedInput-notchedOutline"
                  >
                    <legend
                      class="PrivateNotchedOutline-legendLabelled-3"
                    >
                      <span>
                        Password
                      </span>
                    </legend>
                  </fieldset>
                </div>
              </div>
              
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div
              class="MuiFormControl-root MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                for="password-confirmation"
              >
                Confirm password
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
                required=""
              >
                <input
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
                  id="password-confirmation"
                  required=""
                  type="password"
                  value=""
                />
                <div
                  class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
                >
                  <button
                    aria-label="toggle password confirmation visibility"
                    class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                        />
                      </svg>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                </div>
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-1 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-3"
                  >
                    <span>
                      Confirm password
                    </span>
                  </legend>
                </fieldset>
              </div>
              <p
                class="MuiFormHelperText-root MuiFormHelperText-contained"
              />
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <button
              class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-disableElevation Mui-disabled Mui-disabled"
              disabled=""
              form="user_password"
              tabindex="-1"
              type="submit"
            >
              <span
                class="MuiButton-label"
              >
                Submit
              </span>
            </button>
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1"
          style="padding-top: 12px;"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <a
              class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
              href="/users/sign_in"
            >
              Sign in
            </a>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <a
              class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
              href="/users/sign_up"
            >
              Sign up
            </a>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <a
              class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
              href="/users/unlock/new"
            >
              Didn't receive unlock instructions?
            </a>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root MuiContainer-maxWidthSm"
    >
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      />
    </div>
    <div
      class="MuiContainer-root MuiContainer-maxWidthSm"
    >
      <form
        accept-charset="UTF-8"
        action="/users/password"
        id="user_password"
        method="post"
      >
        <input
          name="_method"
          type="hidden"
          value="put"
        />
        <input
          name="utf8"
          type="hidden"
          value="✓"
        />
        <input
          name="authenticity_token"
          type="hidden"
          value=""
        />
        <input
          id="user_reset_password_token"
          name="user[reset_password_token]"
          type="hidden"
          value="foo"
        />
        <input
          id="user_password"
          name="user[password]"
          type="hidden"
          value=""
        />
        <input
          id="user_password_confirmation"
          name="user[password_confirmation]"
          type="hidden"
          value=""
        />
      </form>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <h3
            class="MuiTypography-root MuiTypography-h3"
          >
            Change your password
          </h3>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div>
            <div
              class="MuiFormControl-root MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                for="password"
              >
                Password
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
                required=""
              >
                <input
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
                  id="password"
                  required=""
                  type="password"
                  value=""
                />
                <div
                  class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
                >
                  <button
                    aria-label="toggle password visibility"
                    class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                        />
                      </svg>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </button>
                </div>
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-1 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-3"
                  >
                    <span>
                      Password
                    </span>
                  </legend>
                </fieldset>
              </div>
            </div>
            
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div
            class="MuiFormControl-root MuiFormControl-fullWidth"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
              data-shrink="false"
              for="password-confirmation"
            >
              Confirm password
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
              required=""
            >
              <input
                aria-invalid="false"
                class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
                id="password-confirmation"
                required=""
                type="password"
                value=""
              />
              <div
                class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
              >
                <button
                  aria-label="toggle password confirmation visibility"
                  class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
                  tabindex="0"
                  type="button"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                      />
                    </svg>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-1 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-3"
                >
                  <span>
                    Confirm password
                  </span>
                </legend>
              </fieldset>
            </div>
            <p
              class="MuiFormHelperText-root MuiFormHelperText-contained"
            />
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-disableElevation Mui-disabled Mui-disabled"
            disabled=""
            form="user_password"
            tabindex="-1"
            type="submit"
          >
            <span
              class="MuiButton-label"
            >
              Submit
            </span>
          </button>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1"
        style="padding-top: 12px;"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <a
            class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
            href="/users/sign_in"
          >
            Sign in
          </a>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <a
            class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
            href="/users/sign_up"
          >
            Sign up
          </a>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <a
            class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
            href="/users/unlock/new"
          >
            Didn't receive unlock instructions?
          </a>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
